(function() {
  function initMotion(scope) {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var host = scope && scope.nodeType === 1 ? scope : document.body;

    if (!gsap || !ScrollTrigger || !host || host.dataset.canspeedMotionReady === 'true') return;
    host.dataset.canspeedMotionReady = 'true';
    gsap.registerPlugin(ScrollTrigger);

    host.querySelectorAll('[data-feature-carousel]').forEach(function(carousel) {
      if (carousel.dataset.featureReady === 'true') return;
      var tabs = Array.prototype.slice.call(carousel.querySelectorAll('[data-feature-tab]'));
      var active = 0;
      var timer = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!tabs.length) return;

      var select = function(index) {
        active = (index + tabs.length) % tabs.length;
        tabs.forEach(function(tab, tabIndex) {
          var selected = tabIndex === active;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      };
      var stop = function() {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      var start = function() {
        stop();
        if (!reducedMotion) timer = window.setInterval(function() { select(active + 1); }, 5000);
      };

      tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() { select(index); });
      });
      carousel.addEventListener('pointerenter', stop);
      carousel.addEventListener('pointerleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function(event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.dataset.featureReady = 'true';
      select(0);
      start();
    });

    /* The header stays fully visible at every scroll position. It used to
       collapse past 56px, which hid the nav links, search, account and cart
       on desktop. That compact state is gone; the hamburger is now purely
       the responsive menu below 980px, driven by CSS.

       This runs before the reduced-motion bail-out so the mobile menu still
       opens for people who have reduced motion turned on. */
    var siteHeader = host.querySelector('.site-header-shell');
    if (siteHeader) {
      var menuToggle = siteHeader.querySelector('.menu-toggle');
      var menuPanel = siteHeader.querySelector('.nav-menu-panel');

      if (menuToggle && menuPanel) {
        var closeMenu = function() {
          menuPanel.classList.remove('is-open');
          menuToggle.setAttribute('aria-expanded', 'false');
        };

        menuToggle.addEventListener('click', function() {
          var open = menuPanel.classList.toggle('is-open');
          menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        menuPanel.querySelectorAll('a').forEach(function(link) {
          link.addEventListener('click', closeMenu);
        });

        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape') closeMenu();
        });
      }
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.context(function() {
      var heroStory = host.querySelector('[data-hero-story]');
      if (heroStory) {
        var heroImages = gsap.utils.toArray('[data-hero-image], .hero-scene-image', heroStory);
        var heroCopies = gsap.utils.toArray('[data-hero-copy]', heroStory);
        if (window.matchMedia('(min-width: 641px)').matches && heroImages.length && heroImages.length === heroCopies.length) {
          var heroFinalHold = 1.15;
          gsap.set(heroImages, { autoAlpha: 0, scale: 1, force3D: true });
          gsap.set(heroCopies, { autoAlpha: 0, y: 24 });
          gsap.set(heroImages[0], { autoAlpha: 1 });
          gsap.to(heroCopies[0], { autoAlpha: 1, y: 0, duration: 0.72, ease: 'power2.out' });

          var heroTimeline = gsap.timeline({
            scrollTrigger: { trigger: heroStory, start: 'top top', end: 'bottom bottom', scrub: 1.1, invalidateOnRefresh: true }
          });

          heroTimeline.to(heroImages[0], { autoAlpha: 1, duration: 0.5, ease: 'none' });
          heroImages.slice(1).forEach(function(unused, offset) {
            var index = offset + 1;
            heroTimeline
              .to(heroCopies[index - 1], { autoAlpha: 0, y: -14, duration: 0.34, ease: 'power1.inOut' })
              .to(heroImages[index - 1], { autoAlpha: 0, duration: 0.42, ease: 'none' }, '<')
              .to(heroImages[index], { autoAlpha: 1, duration: 0.5, ease: 'none' }, '<0.08')
              .to(heroCopies[index], { autoAlpha: 1, y: 0, duration: 0.44, ease: 'power1.out' }, '<0.08')
              .to(heroImages[index], { autoAlpha: 1, duration: index === heroImages.length - 1 ? heroFinalHold : 0.72, ease: 'none' });
          });
        }
      }

      var heroItems = gsap.utils.toArray('[data-motion="hero"] > *', host);
      if (heroItems.length) {
        gsap.fromTo(heroItems, { autoAlpha: 0, y: 24 }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.72,
          ease: 'power2.out',
          stagger: 0.075,
          clearProps: 'transform,opacity,visibility'
        });
      }

      gsap.utils.toArray('[data-reveal]', host).forEach(function(element) {
        gsap.fromTo(element, { autoAlpha: 0, y: 34 }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.78,
          ease: 'power2.out',
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: { trigger: element, start: 'top 88%', once: true }
        });
      });

      gsap.utils.toArray('[data-stagger]', host).forEach(function(group) {
        var items = group.querySelectorAll('[data-reveal-item]');
        if (!items.length) return;
        gsap.fromTo(items, { autoAlpha: 0, y: 22 }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.58,
          ease: 'power2.out',
          stagger: 0.07,
          clearProps: 'transform,opacity,visibility',
          scrollTrigger: { trigger: group, start: 'top 86%', once: true }
        });
      });

      gsap.utils.toArray('[data-parallax] img', host).forEach(function(image) {
        gsap.fromTo(image, { yPercent: -2.5 }, {
          yPercent: 2.5,
          ease: 'none',
          scrollTrigger: {
            trigger: image.closest('[data-parallax]'),
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.55
          }
        });
      });
    }, host);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initMotion(document.body); });
  } else {
    initMotion(document.body);
  }

  document.addEventListener('shopify:section:load', function(event) { initMotion(event.target); });
})();
